export function createSentryInstance(monitoring, sentryDSN: string) {
  const configuration = {
    dataCallback: (data) => {
      data.environment = 'Worker';
      return data;
    },
  };
  return monitoring.createSentryMonitorForApp(sentryDSN, configuration);
}
